import React from "react";
import { FaMobileAlt, FaMicrochip, FaCamera, FaBatteryFull, FaCheckCircle, FaTimesCircle } from "react-icons/fa";

function MobilePhoneDetails({ product }) {
    if (!product) return <p className="productspec-error">Məhsul detalları yüklənmir...</p>;

    const getStatus = (val, yes = "Bəli", no = "Xeyr") =>
        val === true ? yes : val === false ? no : "Bilinmir";

    const specs = [
        { label: "Ad", value: product.name, icon: <FaMobileAlt /> },
        { label: "Şəhər", value: product.city },
        { label: "Kateqoriya", value: product.categoryName },
        { label: "Sub-kateqoriya", value: product.subCategoryName },
        { label: "Marka", value: product.brandName },
        { label: "Model", value: product.modelName },
        { label: "Yaddaş", value: product.storage ? `${product.storage} GB` : null, icon: <FaMicrochip /> },
        { label: "RAM", value: product.ram ? `${product.ram} GB` : null, icon: <FaMicrochip /> },
        { label: "Əməliyyat sistemi", value: product.operatingSystem },
        { label: "5G dəstəyi", value: getStatus(product.is5GSupported), status: product.is5GSupported },
        { label: "Dual SIM", value: getStatus(product.isDualSIM), status: product.isDualSIM },
        { label: "Yaddaş kartı dəstəyi", value: getStatus(product.hasExpandableStorage), status: product.hasExpandableStorage },
        { label: "Əsas kamera", value: product.mainCameraMP ? `${product.mainCameraMP} MP` : null, icon: <FaCamera /> },
        { label: "Ön kamera", value: product.frontCameraMP ? `${product.frontCameraMP} MP` : null, icon: <FaCamera /> },
        { label: "NFC", value: getStatus(product.hasNFC), status: product.hasNFC },
        { label: "Wireless Charging", value: getStatus(product.hasWirelessCharging), status: product.hasWirelessCharging },
        { label: "Batareya", value: product.batteryCapacity ? `${product.batteryCapacity} mAh` : null, icon: <FaBatteryFull /> },
        { label: "Rəng", value: product.color },
        { label: "Vəziyyəti", value: product.condition },
        { label: "Zəmanət", value: getStatus(product.hasWarranty), status: product.hasWarranty }
    ];

    return (
        <div className="productspec-container">
            <div className="productspec-header">
                <FaMobileAlt className="productspec-header__icon" />
                <h3 className="productspec-header__title">Mobil Telefon Məlumatları</h3>
            </div>

            <div className="productspec-grid">
                {specs.map((spec, index) => {
                    if (!spec.value || spec.value === "Bilinmir") return null;
                    
                    return (
                        <div key={index} className="productspec-item">
                            {spec.icon && <span className="productspec-item__icon">{spec.icon}</span>}
                            <div className="productspec-item__content">
                                <span className="productspec-item__label">{spec.label}</span>
                                <span className={`productspec-item__value ${spec.status !== undefined ? (spec.status ? 'productspec-item__value--success' : 'productspec-item__value--neutral') : ''}`}>
                                    {spec.status !== undefined && (
                                        spec.status ? <FaCheckCircle className="productspec-status-icon productspec-status-icon--success" /> : <FaTimesCircle className="productspec-status-icon productspec-status-icon--neutral" />
                                    )}
                                    {spec.value}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>

            {product.description && (
                <div className="productspec-description">
                    <h4 className="productspec-description__title">Əlavə Təsvir</h4>
                    <p className="productspec-description__text">{product.description}</p>
                </div>
            )}
        </div>
    );
}

export default MobilePhoneDetails;